import { render, staticRenderFns } from "./ANA001-RelacionDatos.vue?vue&type=template&id=bd5f877a&scoped=true&"
import script from "./ANA001-RelacionDatos.vue?vue&type=script&lang=js&"
export * from "./ANA001-RelacionDatos.vue?vue&type=script&lang=js&"
import style0 from "./ANA001-RelacionDatos.vue?vue&type=style&index=0&id=bd5f877a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5f877a",
  null
  
)

export default component.exports